<script lang="ts" setup>
import { TirPmModal } from "tir-components";
import { EditQueueModalWrapper, EditQueueModalMain, EditQueueModalEmployees } from "./components";
import { EditQueueEnum } from "./enums";
import { computed, PropType, ref } from "vue";
import { QueueTasksModel } from "../sidebar/models";
import { TaskParametersForm, TaskParameterTypeEnum } from "@/components";

/**Параметры */
const props = defineProps({
  /**Id редактируемой очереди */
  queue: { type: Object as PropType<QueueTasksModel> },
});
/**События */
const emit = defineEmits(["close", "onSave"]);

/**Текущий таб */
const currentTab = ref(EditQueueEnum.Statuses);
/**Режим импорта шаблонов */
const importMode = ref(false);
/**Компонент формы для настройки параметров */
const $taskParametersForm = ref<InstanceType<typeof TaskParametersForm>>();
const $editQueueModalEmployees = ref<InstanceType<typeof EditQueueModalEmployees>>();

const modalTitle = computed(() => {
  if (importMode.value) {
    return `Импорт ${compareTab(EditQueueEnum.Statuses) ? "статусов" : "приоритетов"} в очередь "${props.queue?.Name}"`;
  } else {
    return props.queue?.Name || "";
  }
});

/**Проверка совпадения таба */
const compareTab = (type: EditQueueEnum) => type == currentTab.value;

/**Закрыть окно */
const close = () => {
  if ($editQueueModalEmployees.value?.haveChanges) {
    $editQueueModalEmployees.value?.openLeaveConfirmation(() => {
      emit("close");
    });
    return;
  }
  if ($taskParametersForm.value?.haveChanges) {
    $taskParametersForm.value?.openLeaveConfirmation(() => {
      emit("close");
    });
  } else {
    emit("close");
  }
};
/**Установка значения importMode  */
const setImportMode = (isImport: boolean) => {
  importMode.value = isImport;
};
/**Отмена импорт режима, при нажатии кнопки "Назад" */
const onBackStep = () => {
  $taskParametersForm.value?.setImportForm(false);
};
/**Обновление текущего таба */
const onUpdateTab = (tab: EditQueueEnum) => {
  if (tab == currentTab.value) return;
  if ($editQueueModalEmployees.value?.haveChanges) {
    $editQueueModalEmployees.value?.openLeaveConfirmation(() => {
      currentTab.value = tab;
    });
    return;
  }
  if ($taskParametersForm.value?.haveChanges) {
    $taskParametersForm.value?.openLeaveConfirmation(() => {
      currentTab.value = tab;
    });
  } else {
    currentTab.value = tab;
  }
};
function saveUsersAccess() {
  emit("onSave");
}
</script>
<template>
  <TirPmModal
    classes="edit-queue-modal"
    is-close-overlay
    is-with-step
    :numberStep="1"
    :title="modalTitle"
    :is-visible="!!queue"
    :is-with-back="importMode"
    @close="close"
    @back-step="onBackStep"
  >
    <template #content>
      <EditQueueModalWrapper :tab="currentTab" @update:tab="onUpdateTab">
        <EditQueueModalMain v-if="compareTab(EditQueueEnum.Main)" :queue="queue" />
        <EditQueueModalEmployees
          v-else-if="compareTab(EditQueueEnum.Employees)"
          :queue="queue"
          ref="$editQueueModalEmployees"
          @onSave="saveUsersAccess"
          @onClose="close"
        />
        <TaskParametersForm
          v-else-if="compareTab(EditQueueEnum.Statuses)"
          ref="$taskParametersForm"
          :type="TaskParameterTypeEnum.Status"
          :entity-id="queue.Id"
          @import="setImportMode"
        />
        <TaskParametersForm
          v-else-if="compareTab(EditQueueEnum.Priorities)"
          ref="$taskParametersForm"
          :type="TaskParameterTypeEnum.Priority"
          :entity-id="queue.Id"
          @import="setImportMode"
        />
      </EditQueueModalWrapper>
    </template>
  </TirPmModal>
  <Teleport to="body"> </Teleport>
</template>
<style lang="scss">
.edit-queue-modal.modal {
  width: 76.25rem;
  padding: 1.75rem;

  .modal__content,
  .modal__header {
    padding: 0;
  }

  .modal__header {
    margin-bottom: 1.75rem;
  }

  .edit-queue-modal_border {
    width: 100%;
    height: 0.063rem;
    background-color: var(--neutral-30);
  }
}
</style>
